<template>
  <available-components-for-theme2 :specific-components="components" />
</template>
<script lang="ts">
import AvailableComponentsForTheme2 from '~/components/theme2/AvailableComponentsForTheme2.vue';
import { ViewsMixin } from '~/mixins/views.mixin';

export default defineNuxtComponent({
  name: 'Theme2View',

  mixins: [ViewsMixin],

  components: {
    AvailableComponentsForTheme2,
  },

  description:
    'Components that can be used through this theme should be imported here in order to use them dynamically',
});
</script>
